import React, { useEffect, useState } from "react";
import { config } from "../../../../../../../config";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import close from "../../../../../../../assets/close.svg";
import SimpleBarReact from 'simplebar-react';
// import CustomSelect from "../../../../../../../Util/CustomSelect/CustomSelect";
import { AsyncPaginate } from 'react-select-async-paginate';
import { useHistory } from "react-router";

export default function MoveLeagueModal(props) {
  const teamId = props.teamId;
  const [open, setOpen] = useState(false);
  const [seasons, setSeasons] = useState([]);
  const [seasonName, setSeasonName] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [leagueFilter, setLeagueFilter] = useState({ page: 1, search: '' });
  const [seasonFilter, setSeasonFilter] = useState({ page: 1, search: '' });
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedLeague, setSelectedLeague] = useState(null);
  const history = useHistory();
  const closeModal = () => {
    if (props.closeModal) {
      props.closeModal();
    }
  }
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      fontSize: "13px",
      lineHeight: "16px",
      wordBreak: "break-word",
    }),
    option: (provided, state) => ({
      ...provided,
      cursor: "pointer"
    })
  }

  /**** Triggers when form submit *****/
  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedLeague && selectedLeague.id) {
      axiosApi.post(`${config.apiUrl}/teams/moved`, {
        team_id: teamId,
        league_id: selectedLeague.id,
        prev_league_id: props.leagueId
      }).then((resp) => {
        // history.push(`/admin/leagues/teams?leagueId=${selectedLeague.id}`);

      }).catch((err) => {
        console.error(err);
      });
      closeModal();
    }
  }

  const getLeagues = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/misc/leagues/${selectedSeason?.id || 0}`, { params: { page: page_, search_string: searchString } });
    return seasons.data.data;
  }

  const getAllSeasons = async (page_, searchString) => {
    const seasons = await axiosApi.get(`${config.apiUrl}/seasons`, { params: { page: page_, search: searchString } });
    return seasons.data.data;
  }

  const getLeagueAndSeasonInfo = () => {
    axiosApi.get(
      `${config.apiUrl}/misc/league/season/info/${props.leagueId}`
    ).then(
      (response) => {
        let data = response.data.data;
        setSelectedSeason(data.season)
        setSeasonName(data.season.name);
      }
    )
  }

  useEffect(() => {
    getLeagueAndSeasonInfo();
    getAllSeasons();
    //eslint-disable-next-line
  }, []);

  const loadOptionsLeague = async (searchQuery, loadedOptions, { page }) => {
    setLeagueFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const leagues = await getLeagues(page, searchQuery);
    return {
      options: leagues,
      hasMore: leagues.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsSeason = async (searchQuery, loadedOptions, { page }) => {
    setSeasonFilter((prev) => {
      if (prev.search !== searchQuery) {
        return { search: searchQuery, page };
      }
      return { search: searchQuery, page: page + 1 };
    });
    const seasons = await getAllSeasons(page, searchQuery);
    return {
      options: seasons,
      hasMore: seasons.length === 20,
      additional: {
        page: page + 1,
      },
    };
  };

  return <>
    {open ? <div className="modal season-popup">
      <div className="modal-header">
        <h2>Change Season</h2>
        <p>Select a season</p>
        <span className="close" onClick={() => setOpen(o => !o)}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <div className="modal-body modal-body-seasons">
        {
          <SimpleBarReact style={{ maxHeight: 350 }}>
            {
              seasons.length
                ? seasons.map((season, index) => (
                  <div className={`inner-blk ${index === selectedIndex && 'active'}`}
                    onClick={
                      () => {
                        setSelectedIndex(index);
                      }
                    }>
                    <span>{season.title}</span>
                  </div>))
                : <div className="noSeason">No record found.</div>
            }

          </SimpleBarReact>
        }
      </div>
      <div className="modal-footer d-flex">
        <button type="button" className="cancel-btn" onClick={() => setOpen(o => !o)}>Cancel</button>
        <button onClick={() => { setOpen(o => !o); setSelectedSeason(seasons[selectedIndex]); setSeasonName(seasons[selectedIndex].title) }}>Confirm</button>
      </div>
    </div> :
      <div className="modal season-popup">
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h2>Move Team</h2>
            <p>Select the new league
               {/* or <span onClick={() => { setOpen(o => !o); }}>Change Season</span> */}
               </p>
            <span className="close" onClick={() => props && props.closeModal()}>
              <img src={close} alt='close-icon' />
            </span>
          </div>
          <div className="modal-body modal-body-seasons addTeam-Modal drop-v">
            <div className="drop-down">
              <label>Season</label>
              <AsyncPaginate
                isClearable={true}
                value={selectedSeason}
                classNamePrefix="cs-new-dropdown"
                loadOptions={loadOptionsSeason}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                onChange={(option) => {
                  setSelectedSeason(option);
                }}
                placeholder="Select Season"
                additional={{
                  page: 1,
                }}
                debounceTimeout={1000}
                styles={customStyles}
                noOptionsMessage={() => "No Seasons Found."}
                className="multivalue-dropdown"
              // closeMenuOnSelect={false}
              />
            </div>
            <div className="drop-down">
              <label>League</label>
              <AsyncPaginate
                key={`${selectedSeason?.id}-league-team_move`}
                classNamePrefix="cs-new-dropdown"
                isClearable={true}
                // value={selectedLeagues}
                loadOptions={loadOptionsLeague}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name}
                onChange={(option) => {
                  setSelectedLeague(option);
                }}
                placeholder="Select League"
                additional={{
                  page: 1,
                }}
                debounceTimeout={1000}
                styles={customStyles}
                noOptionsMessage={() => "No Leagues Found."}
                className="multivalue-dropdown"
              // closeMenuOnSelect={false}
              />
            </div>
          </div>
          <div className="modal-footer d-flex">
            <button type="button" className="cancel-btn" onClick={() => closeModal()}>Cancel</button>
            <button>Confirm</button>
          </div>
        </form>
      </div>
    }
  </>
}
